import { motion } from "framer-motion";
import DecodeText from "./DecodeText";

/** Right column: full detail for the selected entry, with all text "encrypting" in. */
export default function EntryDetail({ entry }) {
  if (!entry) return null;
  return (
    <motion.div
      key={entry.id}
      className="detail hud-panel hud-panel--full"
      initial={{ opacity: 0, x: 16 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <span className="hud-corner-tr" aria-hidden="true" />
      <span className="hud-corner-bl" aria-hidden="true" />

      <DecodeText as="h3" className="detail__title hud-title" text={entry.title} duration={700} />
      <DecodeText
        as="p"
        className="detail__meta"
        text={`${entry.org} · ${entry.location}`}
        duration={600}
        delay={90}
      />
      <p className="detail__dates">
        <DecodeText as="span" text={`${entry.start} — ${entry.end}`} duration={500} delay={160} />
        <span className={"pill " + (entry.current ? "pill--cyan" : "pill--gold")}>
          {entry.current ? "Current" : "Complete"}
        </span>
      </p>

      <div className="tick-row" aria-hidden="true" />

      <ul className="detail__bullets">
        {entry.bullets.map((b, i) => (
          <DecodeText as="li" key={i} text={b} duration={750} delay={240 + i * 130} />
        ))}
      </ul>

      {entry.tags?.length > 0 && (
        <div className="detail__tags">
          {entry.tags.map((t) => (
            <span key={t} className="tag">
              {t}
            </span>
          ))}
        </div>
      )}
    </motion.div>
  );
}
